import React from 'react';

import PageTemplate from '../../components/template/PageTemplate';
import { CATEGORY_PAGE_NAME } from '../../constants/service/app/categoryConstants';
import CategoryDetailWrap from '../../views/category/detail/CategoryDetailWrap';

const CategoryDetail = () => {
  return (
    <PageTemplate pageName={CATEGORY_PAGE_NAME.CATEGORY_CREATE_MANAGEMENT}>
      <CategoryDetailWrap />
    </PageTemplate>
  );
};

export default CategoryDetail;
